import { Box, Typography } from '@mui/material';
import React from 'react';

import { BlockHeader, toLocalDateTimeString } from 'lib';
import { BlockHeaderInfoGroup } from './BlockHeaderGroup';

interface BlockHeaderProps {
    headerInfo?: BlockHeader;
}

export const BlockHeaderInfo = (props: BlockHeaderProps): React.JSX.Element => {
    const { headerInfo } = props;

    return (
        <Box>
            <Typography variant='h2'>Header</Typography>
            <BlockHeaderInfoGroup
                label='timestamp'
                value={toLocalDateTimeString(headerInfo?.timestamp)}
            />
            <BlockHeaderInfoGroup label='id' value={headerInfo?.id} />
            <BlockHeaderInfoGroup label='type' value={headerInfo?.type} />
            <BlockHeaderInfoGroup
                label='operation'
                value={headerInfo?.operation}
            />
            <BlockHeaderInfoGroup
                label='owners'
                value={headerInfo?.owners.join(', ')}
            />
            <BlockHeaderInfoGroup
                label='limitedOwners'
                value={headerInfo?.limitedOwners?.join(', ')}
            />
            <BlockHeaderInfoGroup label='signer' value={headerInfo?.signer} />
            <BlockHeaderInfoGroup
                label='signature'
                value={headerInfo?.signature}
            />
            <BlockHeaderInfoGroup
                label='dictionary'
                value={headerInfo?.dictionary}
            />
            <BlockHeaderInfoGroup label='hash' value={headerInfo?.hash} />
        </Box>
    );
};
